import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "country-list" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flag-container" }
const _hoisted_6 = { class: "dots-text filler text-truncate" }

import {computed, nextTick, ref} from "vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import {PhoneCodeCountry} from "~/chat/vue/widget/form/fields/VuePhoneNumberInput/assets/js/phoneCodeCountries";
import ChatModalMessage from "~/chat/vue/widget/ChatModalMessage.vue";
import CountrySelectorExposeInterface
    from "~/chat/vue/widget/form/fields/VuePhoneNumberInput/_subs/CountrySelectorExposeInterface";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "CountrySelector"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    items: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["focus"], ["update:modelValue"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let model = _useModel<any>(__props, "modelValue");

let isFocus = ref(false);
let selectedIndex = ref<number>();
let tmpValue = ref<any>(model.value);
let query = ref<string>();


let itemHeight = computed(() => {
    let itemHeight = parseInt(ConfigStore.siteParams.value.params.designParams.fontSize);
    return itemHeight + itemHeight * 1.55;
});

let filteredItems = computed(() => {
    if (query.value?.length) {
        let q = query.value.toLowerCase();
        return props.items.filter(item => item.name.toLowerCase().indexOf(q) > -1);
    }
    return props.items;
});

function onSearchEnter() {
    if (filteredItems.value.length) {
        model.value = filteredItems.value[0].iso2;
        isFocus.value = false;
    }
}


let selectedCountryIndex = computed(() => {
    return model.value
        ? props.items.findIndex(c => c.iso2 === model.value)
        : null;
});

/*
let instance = getCurrentInstance().proxy;


onMounted(() => {
    instance.$parent.$on('phone-number-focused', () => {
        isFocus.value = false
    });
});
*/

let searchInput = ref<HTMLInputElement>();

function onFocus() {
    emits('focus');
    isFocus.value = true;
    if (model.value) {
        scrollToSelectedOnFocus(selectedCountryIndex.value);
    }
    nextTick(() => searchInput.value.focus());
}


function updateValue(iso2: string) {
    isFocus.value = false;
    tmpValue.value = iso2;
    model.value = iso2;
}

let countriesList = ref<HTMLDivElement>();

function scrollToSelectedOnFocus(arrayIndex: number) {
    nextTick(() => {
        countriesList.value.scrollTop = arrayIndex * itemHeight.value - (itemHeight.value * 3);
    })
}

__expose<CountrySelectorExposeInterface>({
    onFocus
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatModalMessage, {
    visible: _unref(isFocus),
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isFocus) ? (isFocus).value = $event : isFocus = $event)),
    "hide-title": "",
    "without-padding": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "parent",
        class: _normalizeClass([[{
                'has-value': _unref(model)
            }], "field country-selector"]),
        onClick: onFocus
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "searchInput",
              ref: searchInput,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(query) ? (query).value = $event : query = $event)),
              placeholder: `${_unref(__)('SEARCH')}...`,
              type: "text",
              onKeydown: _withKeys(onSearchEnter, ["enter"])
            }, null, 40, _hoisted_3), [
              [_vModelText, _unref(query)]
            ])
          ]),
          _createElementVNode("div", {
            ref_key: "countriesList",
            ref: countriesList,
            class: "country-list-items"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredItems), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.iso2,
                class: _normalizeClass([[
                            {'selected': _unref(model) === item.iso2},
                            {'keyboard-selected': _unref(tmpValue) === item.iso2}
                        ], "d-flex horizontal align-items-center country-list-item"]),
                onClick: _withModifiers(($event: any) => (updateValue(item.iso2)), ["stop"])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`iti-flag-small iti-flag ${item.iso2.toLowerCase()}`)
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)
              ], 10, _hoisted_4))
            }), 128))
          ], 512)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})